import { FC } from 'react'

import { useContactInfo } from '@/api/models/common/hooks/useContactInfo'

import { PROFILE_DOCUMENTS } from '../lib/constants'
import UserDocumentCard from './UserDocumentCard'

const UserDocumentsScreen: FC = () => {
  const { data: contactInfo } = useContactInfo()

  return (
    <div className="flex flex-col gap-12 px-40 pb-40 pt-16 lg:gap-8 lg:px-24 lg:pb-20 lg:pt-0 sm:px-16">
      {PROFILE_DOCUMENTS.map(({ label, linkKey }) => (
        <UserDocumentCard
          key={linkKey}
          label={label}
          link={contactInfo?.[linkKey]}
        />
      ))}
    </div>
  )
}

export default UserDocumentsScreen
